import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import InvestmentInvestTypeDisplay from './investments/investment_invest_type_display';
import InvestmentPortfolioDisplayCard from './investments/investment_portfolio_display_card';
import InvestmentBuySellModal from './investments/investment_buy_sell_modal';
import InvestmentBuySellConfirmModal from './investments/investment_buySell_confirm_modal';
import setInvestmentText from './investments/objects/set_investment_text';
import withLocation from '../../objects/CommonUse/with_location';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import calculateCouponValue from './investments/objects/calculate_coupon_value';
import buildUrl from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import FriendDisplayModal from '../shared-components/friend_display_modal';
import buildUpdateGameInvestmentTranArr from './xMoneyBuilderObjects/build_update_game_investment_tran_arr';
import { determineUpdatesToGameInformation } from './xMoneyBuilderObjects/determine_updates_to_game_information';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    prevProcess: state.prevProcess,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};
 
class InvestmentMainDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state = {
            openBuySell: false,
            openConfirmModal: false,
            headers: setHeadersForFetch(),
            subProcess: "investmentSelectStock",
            environment: Config.dataURL.currentEnv,
            waitState: false,
            rerender: false,
        }  
        this.transactionArr = [];
        this.portfolioArr = [];
        this.displayPortfolio = false;
        this.previousProcess = "";
        this.prepareForDisplay();
       
    }

prepareForDisplay(){
    this.gameMonth = +this.moneyBuildInfo.totalNbrGameMonths - +this.moneyBuildInfo.gameData.gameNbrMonths;
    this.savePreviousProcess();
    this.determineIfFriendsMet();
    this.setMaturityDateArr();
    this.determineDisplayClasses();
}

savePreviousProcess(){
    this.previousProcess = this.props.prevProcess;
}

determineIfFriendsMet(){
    const friendsMetArr = this.moneyBuildInfo.gameData.friendList.filter(elem => elem.introDate !== "");
    if (friendsMetArr.length === 0){
        this.friendsMet = false;
    }else{
        this.friendsMet = true;
    }
}

setMaturityDateArr(){
    this.maturityDateArr = [];
    if (this.moneyBuildInfo.gameInvestments &&
        this.moneyBuildInfo.gameInvestments.length  && this.moneyBuildInfo.gameInvestments.length > 0){
        const bondInvestments = this.moneyBuildInfo.gameInvestments.find(elem => elem.investType === "bond");
        if (bondInvestments){
            this.maturityDateArr = bondInvestments.maturityDateArr;
        }
    }
}

determineDisplayClasses(){
    this.classSize = "col-sm-8 mt-1";
    this.tableClass = "table table-hover table-no-space moneyBuilder-text-size";
}

createOverviewProfile(){
    this.portfolioArr = [];
    let grandTotalInitialValue = 0;
    let grandTotalCurrentValue = 0;
    let grandTotalGainLoss = 0;
    for (let i=0; i<this.moneyBuildInfo.summaryBuyArr.length; i++){
        const summaryBuyArr = this.moneyBuildInfo.summaryBuyArr[i];
        let totalCurrentValue = 0;
        let totalInitialValue = 0;
        let totalGainLoss = 0;
        if (summaryBuyArr.buyTransArr.length > 0){
            for (let j=0; j<summaryBuyArr.buyTransArr.length; j++){
                const buyTransItem = summaryBuyArr.buyTransArr[j];
                const gainLossAmt = (+buyTransItem.totalCurrentPrice - +buyTransItem.totalInitialPrice).toFixed(2);
                totalCurrentValue += +buyTransItem.totalCurrentPrice;
                totalInitialValue += +buyTransItem.totalInitialPrice;
                totalGainLoss += +gainLossAmt;
            }
            totalCurrentValue = totalCurrentValue.toFixed(2);
            totalGainLoss = totalGainLoss.toFixed(2);
        
            const investTextObj = setInvestmentText(summaryBuyArr.investType);
            const investType = investTextObj.headingText + "s";
            const investTypeObj = {investType: investType,  totalInitialValue: totalInitialValue,
                totalCurrentValue: totalCurrentValue, totalGainLoss: totalGainLoss}
            this.portfolioArr.push(investTypeObj);
            grandTotalCurrentValue += +totalCurrentValue;
            grandTotalInitialValue += +totalInitialValue;
            grandTotalGainLoss += +totalGainLoss;
        }
    }
    if (this.portfolioArr.length > 0){
        const investTypeObj = {investType: "Total",  totalInitialValue: grandTotalInitialValue,
            totalCurrentValue: grandTotalCurrentValue, totalGainLoss: grandTotalGainLoss}
        this.portfolioArr.push(investTypeObj);
        this.displayPortfolio = true;
    }else{
        this.displayPortfolio = false;
    }
    if (this.portfolioArr.length > 0){
        this.portfolioArr.sort((a, b) => (a.investType > b.investType) ? 1 : -1);
    }
    this.moneyBuildInfo.summaryBuyArr.sort((a,b) => (a.investType > b.investType) ? 1: -1);
    this.firstTimeIn = true;
}

displayFriendModal(){
    this.askAFriendInfo = {topic: "setupInvestments"};
    this.setState({openFriendModal: true});
}

closeFriendModal(){
    this.setState({openFriendModal: false});
}

openBuySellModal(investType){
    this.investType = investType;
    this.props.selectInvestType(investType);
    this.setState({openBuySell: true});
}

closeBuySellModal(){
    this.setState({openBuySell: false});
}

openBuySellConfirmModal(tranType){
    this.transactionArr.sort((a, b) => (+a.investmentName > b.investmentName) ? 1 : -1);
    if (this.props.investType === "bond"){
        this.determineIfCouponPayout();
    }
    this.tranType = tranType;
    this.setState({openConfirmModal: true});
}

determineIfCouponPayout(){
    this.couponValues = false;
    for (let i=0; i<this.transactionArr.length; i++){
        const shortName = this.transactionArr[i].shortName;
        const investMasterObj = 
            this.moneyBuildInfo.investmentMasterData.find(elem => elem.investShortName === shortName);
        const currentGameDate = this.moneyBuildInfo.gameData.currentGameDate;
        const tranType = this.transactionArr[i].tranType;
        if (investMasterObj && investMasterObj.bondInfo){
            if (investMasterObj.bondInfo.coupon === true ){
                this.couponValues = true;
                const bondInfo = investMasterObj.bondInfo;
                let couponPayOut = calculateCouponValue(bondInfo, currentGameDate, "",
                    tranType, shortName, investMasterObj.classification );
                const totalCouponAmt = +couponPayOut.sellPrice * +this.transactionArr[i].quantity;
                this.transactionArr[i] = {...this.transactionArr[i], coupon: true,
                    couponUnitPrice: couponPayOut.sellPrice, totalCouponAmt: totalCouponAmt};
            }else{
                this.transactionArr[i] = {...this.transactionArr[i], coupon: false,
                    couponUnitPrice: 0, totalCouponAmt: 0  }
            }
        }
    }
}  

closeBuySellConfirmModal(){
    this.setState({openConfirmModal: false});
}

saveMaturityDate(maturityDateObj){
    this.maturityDateArr.push(maturityDateObj);
}

  render() {
        this.createOverviewProfile();
        if (this.firstTimeIn === true){
            this.portfolioDisplay = this.portfolioArr.map((portfolioItem, index) =>
                <InvestmentPortfolioDisplayCard key={index} portfolioInfo={portfolioItem}
                displayPercent={true}
                />
            );
        }
        this.portfolioListInfo =  this.moneyBuildInfo.summaryBuyArr.map((tranSummary, index) =>
            <InvestmentInvestTypeDisplay key={index} investInfo={tranSummary} 
                openBuySellModal={(investType) => this.openBuySellModal(investType)}
            />
        );
      
  return <>
    <div className={this.classSize}>
        <div className="card mt-2 rounded-corners-lg height-max moneyBuilder-text-size">
            <h3 className="mt-4 text-center">Investment Portfolio</h3>
            <div className="overflow-scroll mx-4 mb-5">
                {this.state.waitState   ?
                    <WaitTimeSpinner/>
                :
                <>
                    {this.displayPortfolio ?
                    <div className="container">
                        <div className="table-responsive">
                            <table className="table text-center align-middle
                                table-hover mt-4 table-no-space ">
                                <thead>
                                    <tr>
                                        <th className="text-center table-header-middle">Invest Type</th>
                                        <th className="text-right table-header-middle">Initial Value</th>
                                        <th className="text-right table-header-middle">Current Value</th>
                                        <th className="text-right table-header-middle">Profit/Loss</th>
                                        <th className="text-right">Profit/Loss <br/> Percent</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.portfolioDisplay}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    :
                        <div className="mt-4">
                            You do not currently own any type of investment. Review the information
                            below and then click on the "Buy" button to buy the investment(s)
                            of your choice.
                        </div>
                    }
                      {this.friendsMet && (
                        <div className="text-right mr-4">
                            <Button
                                variant="info"
                                onClick={() => this.displayFriendModal()}
                            >
                                Ask a Friend
                            </Button>
                        </div>
                    )}
                    <div className="mt-4">
                        {this.portfolioListInfo}
                    </div>
                   
                </>
                }
            </div>
            {this.state.openBuySell  ?
                <InvestmentBuySellModal  
                    show={this.state.openBuySell}
                    investType = {this.investType}
                    tranType = {this.props.tranType}
                    onOpen ={()=> this.props.inputSelected(3)}
                    onClose={() => this.closeBuySellModal()}
                    currentGameMonth={this.props.currentGameMonth}
                    summaryTranArr = {this.props.summaryTranArr}
                    transactionArr = {this.transactionArr}
                    buyTranArr = {this.props.buyTranArr} 
                    investmentMasterArr = {this.props.investmentMasterArr}
                    setBuyOrSell = {(buttonText) => this.props.setBuyOrSell(buttonText)}
                    moneyBuildInfo = {() => this.props.moneyBuildInfo()} 
                    saveTransaction={(investment) => this.saveTransaction(investment)}
                    saveMaturityDate={(maturityDateObj) => this.saveMaturityDate(maturityDateObj)}
                    openConfirmModal={(tranType) => this.openBuySellConfirmModal(tranType)}
                />
            :
                null
            }

            {this.state.openConfirmModal  ?
                <InvestmentBuySellConfirmModal
                    show={this.state.openConfirmModal}
                    investType={this.props.investType}
                    tranType={this.tranType}
                    currentCash={this.moneyBuildInfo.gameData.currentCash}
                    purchaseArr={this.transactionArr}
                    couponValues={this.couponValues}
                    onClose={() => this.closeBuySellConfirmModal()}
                    confirmBuyOrSell={(confirmObj) => this.transactionHasBeenConfirmed(confirmObj)}
                />
            :
                null
            }

             {this.state.openFriendModal && (
                <FriendDisplayModal
                    show={this.state.openFriendModal}
                    title={""}
                    gameProcess="GameViews"
                    askAFriendInfo={this.askAFriendInfo}
                    friendData={this.state.emptyArr}
                    onClose={() => this.closeFriendModal()}
                    gameInfo={() => this.props.moneyBuildInfo()}
                    />
            )}
        </div>
    </div>   
</>
  }

componentDidMount(){
    this._isMounted = true;
    
}

saveTransaction(investment){
    // check if this investment is already in the table  
    // --->  problem sell trans will have multiple for same business...  so can't remove dups
    // by investment.shortName....   remove dups using transNbr (will need to add transNbr to purchase trans??)
    const indx = this.transactionArr.findIndex(elem => elem.shortName + elem.transNbr === 
        investment.shortName + investment.transNbr);
    if (indx !== -1){
        if (+investment.quantity === 0 || investment.quantity === undefined){
            this.transactionArr.splice(indx, 1);
        }else{
            this.transactionArr[indx].quantity = investment.quantity;
            this.transactionArr[indx].totalAmount = investment.totalAmount;
        }
    }else{
        const masterObj = 
        this.moneyBuildInfo.investmentMasterData.find(elem => elem.investShortName === investment.shortName);
        const transactionArrObj = {investmentName: masterObj.investmentName, quantity: investment.quantity,
            totalAmount: investment.totalAmount, unitPrice: investment.currentPrice, 
            tranType: investment.tranType, shortName: investment.shortName, 
            transNbr: investment.transNbr, initialBuyQty: investment.initialBuyQty};
        this.transactionArr.push(transactionArrObj);
    }
 
    this.setState({purchaseMade: true});
}

transactionHasBeenConfirmed(){
    // update the game-investments and unlocked-features and icon-table
    // also update the game cash, icon table and unlocked features
    // decided not to update mood points for investments
    this.setState({openConfirmModal: false, waitState: true, openBuySell: false});
    let currentDateTime = getCurrentDateTime();
    let currentDate = currentDateTime.date;
    this.gameID = this.moneyBuildInfo.gameData._id;
    this.historyTranArr = [];
    const gameInvestmentUpdateObj = buildUpdateGameInvestmentTranArr(this.props.investType, currentDate,
        this.moneyBuildInfo.gameInvestments, this.transactionArr, this.moneyBuildInfo.gameData.currentGameDate, 
        this.gameMonth, this.gameID, this.maturityDateArr );
    this.cashChg = gameInvestmentUpdateObj.cashChg;
    this.gameInvestmentObj = gameInvestmentUpdateObj.gameInvestmentObj;
    if (gameInvestmentUpdateObj.gameInvestHistoryObj.gameID){
        this.updateGameInvestHistory(gameInvestmentUpdateObj.gameInvestHistoryObj);
    }
    const currentlyActive = gameInvestmentUpdateObj.currentlyActive;
    const gameUpdtObj = determineUpdatesToGameInformation(this.moneyBuildInfo.gameData, this.cashChg,
         currentlyActive);
    this.props.setMoneyBuildInfo(this.moneyBuildInfo.gameData, "gameData");
    this.updateGameData(gameUpdtObj.gameBodyObj);
    if (gameUpdtObj.updateConditionTable === true){
        this.updateConditionsTable();
    }
    this.props.setInfoRedux(this.moneyBuildInfo.gameData, "gameData");
    this.updateGameTransactions();
    this.props.setInfoRedux(true, "refreshInvestments");
    this.transactionArr = [];
}  

updateGameTransactions(){
    const funcName = "updateGameInvestments";
    const urlParm = "?gameID=" + this.gameID + "&investType=" + this.investType;
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    fetch(uri,
        {
            method: 'PUT', 
            headers: this.state.headers,
            body: JSON.stringify(this.gameInvestmentObj)
        })
        .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (output.statusCode === 200){ 
                //  update of gameTransactions was successful
                this.props.reloadGameInvestments();
                if(this.state.timeout) clearTimeout(this.state.timeout);
                        this.state.timeout = setTimeout(() => {
                        this.setState({waitState: false});;
                }, 1000);
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: this.gameInvestmentObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

updateGameInvestHistory(gameInvestHistoryObj){
    const funcName = "updateGameInvestHistory";
    const urlParm = "?gameID=" + this.gameID + "&investType=" + this.investType;
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    fetch(uri,
        {
            method: 'PUT', 
            headers: this.state.headers,
            body: JSON.stringify(gameInvestHistoryObj)
        })
        .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (output.statusCode === 200){ 
                //  update of gameInvestHistory was successful
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: this.gameInvestmentObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

updateGameData(bodyObj){
    const funcName = "updateUnlockedFeatures";
    const urlParm = "?updateMoodPoints=false";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
        {method:'PUT', headers: this.state.headers,
        body: JSON.stringify(bodyObj)})
        .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                //  successful update of gameData
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

updateConditionsTable() {
    const funcName = "updateConditions";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    // Update conditions table in Mongo
    const bodyObj = { "conditionsTable": this.moneyBuildInfo.gameData.conditionsTable };
    fetch(uri,
        {
            method: 'PUT', headers: this.state.headers,
            body: JSON.stringify(bodyObj)
        })
        .then(response => {
            if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (output.statusCode === 200){ 
                // updateConditions Table was successful;
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: bodyObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

}

export default connect(mapStateToProps, mapDispatchToProps)(withLocation(InvestmentMainDisplay));